(ns ycweb.app.website.footer.footer
  (:require
   [rum.core :as rum]
   [ycweb.app.website.banner.banner :as banners]
   [ycweb.app.website.footer.footernav :as footernav]
   [ycweb.app.website.footer.newslettersignup :as newslettersignup]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.svg-icons :as svg-icons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.util.core :as u]))

;; Social Links Component
(rum/defc social-links [app-atom]
  [:ul.social-icons-list.u-margin-top-16
   {:role "listbox"}
   [:li.social-icons-list__item
    [:a
     {:href "https://www.facebook.com/yuppiechef"
      :class (u/bem :social-icon [:facebook])}
     [:i {:class (u/bem :icon [:block :default :is-dark :facebook])}]
     [:span.u-hidden-from-view "Facebook"]]]
   [:li.social-icons-list__item
    [:a
     {:href "https://twitter.com/yuppiechef"
      :class (u/bem :social-icon [:twitter])}
     [:i {:class (u/bem :icon [:block :default :is-dark :twitter])}]
     [:span.u-hidden-from-view "Twitter"]]]
   [:li.social-icons-list__item
    [:a
     {:href "https://instagram.com/yuppiechef/"
      :class (u/bem :social-icon [:instagram])}
     [:i {:class (u/bem :icon [:block :default :is-dark :instagram])}]
     [:span.u-hidden-from-view "Instagram"]]]
   [:li.social-icons-list__item
    [:a
     {:href "https://www.pinterest.com/yuppiechef/"
      :class (u/bem :social-icon [:pinterest])}
     [:i {:class (u/bem :icon [:block :default :is-dark :pinterest])}]
     [:span.u-hidden-from-view "Pinterest"]]]
   [:li.social-icons-list__item
    [:a
     {:href "https://www.youtube.com/yuppiechef"
      :class (u/bem :social-icon [:youtube])}
     [:i {:class (u/bem :icon [:block :default :is-dark :youtube])}]
     [:span.u-hidden-from-view "Youtube"]]]])

(rum/defc footer < rum/reactive
  [app-atom {:keys [banner-type] :as options}]
  (let [mobile? (cmn/curact app-atom [:mobile?])
        full-page? (cmn/curact app-atom [:app :full-page?])]
    [:footer.footer
     (when banner-type
       [:div
        (banners/footer-banner-ads app-atom options)])
     [:div
      (newslettersignup/newslettersignup app-atom)]
     [:div
      {:class (u/bem :yc-section [:standard-underline])}
      [:div
       {:class (u/bem :flex-grid-group [:ml-align-right])}
       [:div
        {:class (u/bem :flex-grid-block [:fluid])}
        (social-links app-atom)]]]
     (footernav/footernav app-atom options)
     [:div
      {:class (u/bem :yc-section [:standard])}
      [:aside.payment-logos
       [:span.u-hidden-from-view
        "Yuppiechef accepts the following payment options: "]
       [:span.u-hidden-from-view
        "Learn more about our payment options."]
       [:a.block-link
        {:href "/help.htm?action=category&id=2&name=Payment--Pricing"}
        [:span.u-hidden-from-view "Learn more about our payment options."]
        (svg-icons/svg-icon-visa {:icon-class "footer-pay-icon"})
        (svg-icons/svg-icon-mastercard {:icon-class "footer-pay-icon"})
        (svg-icons/svg-icon-dinersclub {:icon-class "footer-pay-icon"})
        (svg-icons/svg-icon-amex {:icon-class "footer-pay-icon"})
        (svg-icons/svg-icon-discovery {:icon-class "footer-pay-icon"})
        (svg-icons/svg-icon-ebucks {:icon-class "footer-pay-icon"})
        (svg-icons/svg-icon-mobicred {:icon-class "footer-pay-icon"})
        (when (cmn/curact app-atom [:features :payflex])
          (svg-icons/svg-icon-payflex {:icon-class "footer-pay-icon"}))
        (svg-icons/svg-icon-snapscan {:icon-class "footer-pay-icon"})
        (svg-icons/svg-icon-zapper {:icon-class "footer-pay-icon"})
        (svg-icons/svg-icon-eft {:icon-class "footer-pay-icon"})]]
      [:p.u-text-center.u-margin-top-30
       {:class (u/bem :yc-paragraph [:small])}
       "© Yuppiechef Online (Pty) Ltd"]
      [:p.yc-paragraph.yc-paragraph--small-force.u-text-center
       "This page is protected by reCAPTCHA and Google's "
       [:a.text-link {:href "https://policies.google.com/privacy" :target "_blank"} "privacy policy"]
       " and "
       [:a.text-link {:href "https://policies.google.com/terms" :target "_blank"} "terms of service"]
       " apply."]]
     (when-not full-page?
       [:nav.u-text-center
        {:class (u/bem :yc-section [:large])}
        (buttons/button-web (str "Switch to " (if mobile? "desktop" "mobile"))
          {:href (cmn/curact app-atom [:page :switch-display-url])
           :style :secondary
           :icon :desktop})])]))

(defmethod flow/render-screen :web.footer [app-atom _]
  (footer app-atom {}))
